import { createBrowserRouter } from 'react-router-dom';
import { Home } from '../pages/home';

export const router = createBrowserRouter([
  {
    path: '/attestation/:instanciaId/:entidadeId/:vidaId',
    element: <Home />,
  },
]);
